/*global angular:true*/
angular.module('jcsfApp').directive('focus', function () {
    return function (scope, element) {
        element[0].focus();
    };
}).directive('passwordMatch', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                require: 'ngModel',
                link: function (scope, elem, attrs, control) {
                    var checker = function () {

                        var e1 = scope.$eval(attrs.ngModel);

                        var e2 = scope.$eval(attrs.passwordMatch);
                        if (e2 !== null)
                            return e1 === e2;
                    };
                    scope.$watch(checker, function (n) {

                        control.$setValidity("passwordNoMatch", n);
                    });
                }
            };
        }
])
    .directive('checklistModel', ['$parse', '$compile', function ($parse, $compile) {
        function contains(arr, item) {
            if (angular.isArray(arr)) {
                for (var i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        return true;
                    }
                }
            }
            return false;
        }

        function add(arr, item) {
            arr = angular.isArray(arr) ? arr : [];
            for (var i = 0; i < arr.length; i++) {
                if (angular.equals(arr[i], item)) {
                    return arr;
                }
            }
            arr.push(item);
            return arr;
        }

        function remove(arr, item) {
            if (angular.isArray(arr)) {
                for (var i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        arr.splice(i, 1);
                        break;
                    }
                }
            }
            return arr;
        }

        function postLinkFn(scope, elem, attrs) {
            $compile(elem)(scope);

            var getter = $parse(attrs.checklistModel);
            var setter = getter.assign;

            var value = $parse(attrs.checklistValue)(scope.$parent);

            scope.$watch('checked', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                var current = getter(scope.$parent);
                if (newValue === true) {
                    setter(scope.$parent, add(current, value));
                } else {
                    setter(scope.$parent, remove(current, value));
                }
            });

            scope.$parent.$watch(attrs.checklistModel, function (newArr, oldArr) {
                scope.checked = contains(newArr, value);
            }, true);
        }

        return {
            restrict: 'A',
            priority: 1000,
            terminal: true,
            scope: true,
            compile: function (tElement, tAttrs) {
                if (tElement[0].tagName !== 'INPUT' || !tElement.attr('type', 'checkbox')) {
                    throw 'checklist-model should be applied to `input[type="checkbox"]`.';
                }

                if (!tAttrs.checklistValue) {
                    throw 'You should provide `checklist-value`.';
                }

                tElement.removeAttr('checklist-model');

                tElement.attr('ng-model', 'checked');

                return postLinkFn;
            }
        };
    }])
    .directive('phoneInput', ['$filter', '$browser', function ($filter, $browser) {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModelCtrl) {
                var listener = function () {
                    var value = $element.val().replace(/[^0-9]/g, '');
                    $element.val($filter('tel')(value, false));
                };

                ngModelCtrl.$parsers.push(function (viewValue) {
                    return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
                });

                ngModelCtrl.$render = function () {
                    $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
                };

                $element.bind('change', listener);
                $element.bind('keydown', function (event) {
                    var key = event.keyCode;
                    if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener);
                });

                $element.bind('paste cut', function () {
                    $browser.defer(listener);
                });
            }

        };
    }])
    .directive('checkUnique', ['studentsService', function (dataService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                element.bind('blur', function (e) {
                    if (!ngModel || !element.val()) return;
                    var keyProperty = scope.$eval(attrs.checkUnique);
                    var currentValue = element.val();
                    dataService.isUnique(keyProperty.key, keyProperty.property, currentValue)
                        .then(function (unique) {
                            ngModel.$setValidity('unique', unique);

                        }, function () {
                            ngModel.$setValidity('unique', true);
                        });
                });
            }
        }
    }])
 .filter('tel', function () {
     return function (tel) {
         if (!tel) { return ''; }

         var value = tel.toString().trim().replace(/^\+/, '');

         if (value.match(/[^0-9]/)) {
             return tel;
         }

         var country, city, number;

         switch (value.length) {
             case 1:
             case 2:
             case 3:
                 city = value;
                 break;

             default:
                 city = value.slice(0, 3);
                 number = value.slice(3);
         }

         if (number) {
             if (number.length > 3) {
                 number = number.slice(0, 3) + '-' + number.slice(3, 7);
             }
             else {
                 number = number;
             }

             return ("(" + city + ") " + number).trim();
         }
         else {
             return "(" + city;
         }

     };
 });
;
